import { atom } from 'recoil';
import { getBankAccountValidityStatusSelector } from '../selectors/getBankAccountValidityStatusSelector';

export const bankAccountValidityStatusAtom = atom<boolean>({
    key: 'bankAccountValidityStatus',
    default: getBankAccountValidityStatusSelector
});
